import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RegistrationForm from './RegistrationForm';
import { ArrowRightIcon } from './icons/OrganicIcons';

const IniciaFormPage = () => {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleVolverClick = () => {
    navigate('/inicia');
  };

  return (
    <div className={`min-h-screen portal-section transition-all duration-1000 ${mounted ? 'opacity-100' : 'opacity-0'}`}>
      {/* Fondo animado estilo Pixar */}
      <DigitalForestBackground />
      
      {/* Header */}
      <header className="relative z-20 bg-white/80 backdrop-blur-md border-b border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={handleVolverClick}
              className="flex items-center space-x-3 text-neutral-600 hover:text-green-400 transition-colors duration-200 group"
            >
              <div className="p-2 rounded-xl group-hover:bg-white/50 transition-all duration-200">
                <ArrowRightIcon className="w-5 h-5 rotate-180" />
              </div>
              <span className="font-medium" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>Volver a información</span>
            </button>
            <div className="relative">
              <img 
                src="/LOGO GUIA.png" 
                alt="GUIA AI Logo" 
                className="h-12 drop-shadow-soft"
              />
              <div className="absolute -inset-2 bg-gradient-to-br from-cyan-400 to-purple-400 opacity-10 rounded-full blur-lg"></div>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative z-10 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className={`space-y-6 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`}>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-neutral-700 leading-tight drop-shadow-lg" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Únete a <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">INICIA</span>
            </h1>
            <p className="text-lg max-w-2xl mx-auto text-neutral-600 leading-relaxed" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Completa el formulario y comienza tu transformación digital
            </p>
          </div>
        </div>
      </section>

      {/* Registration Form Section */}
      <section className="relative z-10 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <RegistrationForm />
        </div>
      </section>

      {/* Footer */}
      <footer className="relative z-20 bg-neutral-900/90 backdrop-blur-md border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <img 
              src="/LOGO GUIA.png" 
              alt="GUIA AI Logo" 
              className="h-16 mx-auto opacity-80"
            />
            <div className="absolute -inset-4 bg-gradient-to-br from-cyan-400 to-purple-400 opacity-10 rounded-full blur-xl"></div>
            <p className="text-neutral-400 font-medium mt-4" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              'Inteligencia que marca el rumbo'
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Componente de fondo digital forest con estilo Pixar (igual que en LandingPage)
const DigitalForestBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Gradiente de fondo más cálido y acogedor */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, #e8f5e8 0%, #b8e6ff 40%, #a3e6c1 80%, #e0fff7 100%)'
        }}
      />
      
      {/* Líneas verticales del bosque - más suaves y orgánicas */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="absolute top-0 w-1 bg-gradient-to-b from-transparent via-white/20 to-transparent"
          style={{
            left: `${Math.random() * 100}%`,
            height: '120vh',
            animation: `forest-down ${8 + Math.random() * 4}s linear infinite`,
            animationDelay: `${Math.random() * 8}s`,
            opacity: 0.3 + Math.random() * 0.4,
            filter: 'blur(0.5px)'
          }}
        />
      ))}
      
      {/* Partículas mágicas flotantes - más suaves y naturales */}
      {[...Array(20)].map((_, i) => (
        <div
          key={`particle-${i}`}
          className="absolute rounded-full bg-white/30 backdrop-blur-sm"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${4 + Math.random() * 8}px`,
            height: `${4 + Math.random() * 8}px`,
            animation: `particle-up ${10 + Math.random() * 10}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 10}s`,
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.5)'
          }}
        />
      ))}
      
      {/* Halos de luz suaves */}
      {[...Array(8)].map((_, i) => (
        <div
          key={`halo-${i}`}
          className="absolute rounded-full bg-gradient-radial from-white/20 to-transparent"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${100 + Math.random() * 200}px`,
            height: `${100 + Math.random() * 200}px`,
            animation: `breathe ${6 + Math.random() * 4}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 6}s`
          }}
        />
      ))}
    </div>
  );
};

export default IniciaFormPage;
